<template>
  <section>
    <h1>
      How Much Do The
      <span class="highlight">Top-grossing Video Games</span> Actually Make?
    </h1>

    <p>
     Have you ever wondered how much revenue the top-grossing AAA and Free to Play (F2P) game are generating for their publishers?<br><br> 
With digital downloads, microtransactions and DLC items now so lucrative, the team at NetBet trawled through 24 months of sales and revenue data to reveal how much the most popular games in the world are raking in per second, minute, hour and day.
<br><br>These are the results…
    </p>
  </section>
</template>

<style lang="scss" scoped>
.highlight {
  color: $orange;
}

section {
  
    padding: 0px 20px 0px 20px;
  
}
</style>